import React from 'react';
import { Box, Container, Grid, Typography, Link } from '@mui/material';
import { ArrowForward, CalendarMonth, Email, Phone } from '@mui/icons-material';
import SocialMediaIcons from './SocialMediaIcons';

const FooterMain = () => {
    const widgetLinks = [
        {
            title: 'ABOUT BEADS',
            links: [
                { name: 'OUR PROJECTS', to: '/overview-tab' },
                { name: 'GET INVOLVED', to: '/donate' },
                { name: 'DONATE', to: '/donate' },
                { name: 'BLOG', to: '/news' },
                { name: 'SPONSORS', to: '/friends-of-beads' },
            ],
        },
        {
            title: 'COMMUNITY INVOLVEMENT',
            links: [
                { name: 'FAMINE AWARENESS', to: '/famine-relief' },
                { name: 'CLIMATE CHANGE', to: 'https://climatechange-makers.netlify.app/', isExternal: true },
                { name: 'SUCCESS STORIES', to: '/success-stories' },
                { name: 'SEGAL FOUNDATION', to: 'https://www.segalfamilyfoundation.org/', isExternal: true },
                { name: 'GIRL CHILD SUPPORT', to: '/donate' },
            ],
        },
        {
            title: 'MORE LINKS',
            links: [
                {
                    name: 'BEADS for Education, Inc  [CFC #83026]',
                    date: 'January 11, 2014',
                    image: 'assets/img/widget/1.png',
                    to: '/news',
                },
                {
                    name: 'BEADS for Education, Inc  [CFC #83026]',
                    date: 'January 11, 2023',
                    image: 'assets/img/widget/2.jpg',
                    to: '/news',
                },
            ],
        },
    ];

    const linkStyle = {
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none !important',
        color: '#fff',
        fontSize: '0.875rem',
        marginBottom: '0.5rem',
        '&:hover .arrow-icon': {
            color: '#f39c12',
        },
    };

    return (
        <Container maxWidth="lg" sx={{ pt: 5 }}>
            <Grid container spacing={4}>
                <Grid item xs={12} sm={6} md={3}>
                    <Box className="widget widget_about">
                        <Box className="thumb" sx={{ mb: 1, img: { maxWidth: 150 } }}>
                            <Typography variant="h6" color="white" gutterBottom>
                                CONTACT US
                            </Typography>
                        </Box>

                        <Box className="details">
                            <Typography color="white" gutterBottom>
                                BEADS for Education, Inc is a 501(c)(3) tax-exempt organization.
                            </Typography>
                            <Typography color="white" mt={2}>
                                <Phone /> (+254) 609-992 7891
                            </Typography>
                            <Typography color="white" mt={2}>
                                <Email /> BEADSofKenya@aol.com
                            </Typography>
                            <SocialMediaIcons />
                        </Box>
                    </Box>
                </Grid>


                {widgetLinks.map((widget, index) => (
                    <Grid item xs={12} sm={6} md={3} key={index}>
                        <Box className="widget">
                            <Typography variant="h6" color="white" gutterBottom>
                                {widget.title}
                            </Typography>
                            {widget.links.map((link, linkIndex) => (
                                <Box key={linkIndex} sx={{ mb: 2 }}>
                                    {link.date ? (
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Box component="img" src={link.image} alt="logo" sx={{ width: 80, height: 80, borderRadius: 10, mr: 2 }} />
                                            <Box>
                                                <Typography variant="body2" color="white" sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <CalendarMonth size={14} sx={{ marginRight: '5px' }} />
                                                    {link.date}
                                                </Typography>
                                                <Link href={link.to} color="#fff" sx={{ textDecoration: 'none' }}>
                                                    {link.name}
                                                </Link>
                                            </Box>
                                        </Box>
                                    ) : (
                                        <Typography color="white">
                                            <Link
                                                href={link.to}
                                                color="inherit"
                                                sx={linkStyle}
                                                target={link.isExternal ? "_blank" : "_self"}
                                                rel={link.isExternal ? "noopener noreferrer" : ""}
                                            >
                                                <ArrowForward className="arrow-icon" sx={{ marginRight: '0.4rem', color: '#333f4d' }} />
                                                {link.name}
                                            </Link>
                                        </Typography>
                                    )}
                                </Box>
                            ))}
                        </Box>
                    </Grid>
                ))}
            </Grid>

        </Container>
    );
};

export default FooterMain;
